<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <lucky-wheel-report-table />
      </b-col><!--/.col-->
    </b-row><!--/.row-->
  </div>

</template>

<script>
  import LuckyWheelReportTable from './LuckyWheelReportTable.vue'

  export default {
    name: 'luckywheel-report',
    components: {LuckyWheelReportTable}
  }
</script>



// WEBPACK FOOTER //
// src/views/report/mini-games/luckywheel/LuckyWheelReport.vue